import { useLingui } from "@lingui/react";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const ChassisVariant = ({ chassisVariant }: SpecProps<"chassis_variant">) => {
  const { i18n } = useLingui();

  if (!chassisVariant) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.chassisVariant",
    message: "Chassis variant",
    comment: "Label for 'Chassis variant'",
  });

  return <FieldValuePair field={field} value={chassisVariant} />;
};
